// Sidebar group configuration kept separate from the component so that
// react-refresh (Fast Refresh) keeps working: a component file should
// only export components.

import type { JSX } from "react";
import {
  IconAssociation,
  IconBuilding,
  IconBuildings,
  IconChart,
  IconCluster,
  IconDashboard,
  IconDisc,
  IconFeedback,
  IconFile,
  IconKey,
  IconLayers,
  IconLogs,
  IconMail,
  IconMic,
  IconShield,
  IconTodo,
  IconUsers,
} from "./Icons";

export type AdminTab =
  | "overview"
  | "users"
  | "associations"
  | "departments"
  | "organizations"
  | "templates"
  | "team_templates"
  | "audio_preview"
  | "stats"
  | "visitors"
  | "recordings"
  | "dept_recordings"
  | "recording_feedback"
  | "logs"
  | "emails"
  | "feedback"
  | "roles_permissions"
  | "rate_limits"
  | "signup_bans"
  | "tier"
  | "cluster"
  | "todos"
  | "telemetry"
  | "it_overview"
  | "lexicon";

export type SidebarItem = {
  key: AdminTab;
  label: string;
  icon: (props: { className?: string }) => JSX.Element;
};

export type SidebarGroup = {
  caption: string | null;
  items: SidebarItem[];
};

export const SIDEBAR_GROUPS: SidebarGroup[] = [
  {
    caption: null,
    items: [
      { key: "overview", label: "Overzicht", icon: IconDashboard },
      { key: "users", label: "Gebruikers", icon: IconUsers },
      { key: "dept_recordings", label: "Afdelingsopnames", icon: IconMic },
      { key: "todos", label: "Todo's", icon: IconTodo },
    ],
  },
  {
    caption: "Beheer",
    items: [
      { key: "organizations", label: "Organisaties", icon: IconBuildings },
      { key: "departments", label: "Afdelingen", icon: IconBuilding },
      { key: "associations", label: "Associaties", icon: IconAssociation },
      { key: "it_overview", label: "IT-overzicht", icon: IconLogs },
    ],
  },
  {
    caption: "Inhoud",
    items: [
      { key: "templates", label: "Templates", icon: IconFile },
      { key: "team_templates", label: "Team-sjablonen", icon: IconFile },
      { key: "audio_preview", label: "Audio preview", icon: IconMic },
      { key: "lexicon", label: "Lexicon", icon: IconFile },
    ],
  },
  {
    caption: "Systeem",
    items: [
      { key: "stats", label: "Statistieken", icon: IconChart },
      { key: "telemetry", label: "Telemetrie", icon: IconChart },
      { key: "visitors", label: "Bezoekers", icon: IconChart },
      { key: "recordings", label: "Opnames", icon: IconDisc },
      { key: "recording_feedback", label: "Opname-feedback", icon: IconFeedback },
      { key: "logs", label: "Logs", icon: IconLogs },
      { key: "emails", label: "E-mail", icon: IconMail },
      { key: "feedback", label: "Feedback", icon: IconFeedback },
    ],
  },
  {
    caption: "Configuratie",
    items: [
      { key: "roles_permissions", label: "Rollen & rechten", icon: IconKey },
      { key: "rate_limits", label: "Rate limits", icon: IconShield },
      { key: "signup_bans", label: "Blokkades", icon: IconShield },
      { key: "tier", label: "Tiers", icon: IconLayers },
      { key: "cluster", label: "Cluster", icon: IconCluster },
    ],
  },
];
